import { useMemo } from 'react'

import { useScreen } from '@/store/screen'

export const useRecommendedArticles = () => {
  const { windowSize, isBiggerMobile, isMobile, isTablet } = useScreen()

  const fontSizesByScreenSize = useMemo(() => {
    const fontsSizesByScreen = {
      1440: {
        title: 'h2' as const,
      },
      791: {
        title: 'h5' as const,
      },
    }
    return fontsSizesByScreen
  }, [])

  const { width } = windowSize
  const fontSizes = useMemo(() => {
    if (!width) return fontSizesByScreenSize[1440]
    if (width) return fontSizesByScreenSize[791]

    return fontSizesByScreenSize[1440]
  }, [width, fontSizesByScreenSize])

  return {
    fontSizes,
    isBiggerMobile,
    isMobile,
    isTablet,
  }
}
